export default __webpack_public_path__ + "static/media/event-type.2b1a0c3a.svg";